import { useState, useEffect, useCallback } from 'react';
import { organizationService } from '../services/organizationService';
import { Organization } from '../types/organization';
import { useAuth } from '../contexts/AuthContext';
export const useOrganizations = () => {
  const { user } = useAuth();
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [loading, setLoading] = useState(true);

  const loadOrganizations = useCallback(async () => {
    if (!user) {
      setOrganizations([]);
      setLoading(false);
      return;
    }

    // Customer szerepkörű felhasználóknak nincs szükségük szervezet listára
    if (user.role === 'customer') {
      setOrganizations([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      let orgs: Organization[] = [];

      if (user.role === 'super_admin') {
        orgs = await organizationService.getAllOrganizations();
      } else if (user.id) {
        // Lekérjük azokat a szervezeteket ahol:
        // 1. A felhasználó tulajdonos
        const ownedOrgs = await organizationService.getUserOrganizations(user.id);
        
        // 2. A felhasználó tag
        const allOrgs = await organizationService.getAllOrganizations();
        const memberOrgs = allOrgs.filter(org => 
          org.users?.some(u => u.userId === user.id)
        );

        // Egyesítjük a listákat, kiszűrve a duplikációkat
        orgs = [...ownedOrgs];
        memberOrgs.forEach(org => {
          if (!orgs.find(o => o.id === org.id)) {
            orgs.push(org);
          }
        });
      }

      setOrganizations(orgs);
    } catch (error) {
      console.error('Error loading organizations:', error);
      setOrganizations([]);
    } finally {
      setLoading(false);
    }
  }, [user]);

  // Első betöltés
  useEffect(() => {
    loadOrganizations();
  }, [loadOrganizations]);

  // Frissítés függvény
  const refetch = useCallback(async () => {
    await loadOrganizations();
  }, [loadOrganizations]);

  return { organizations, loading, refetch };
}; 